module.exports = __webpack_public_path__ + "static/media/1.508fb9b2.svg";